export const BUTTONS = ['backTop', 'scrollDownTip', 'copyright'];
